(function() {
    'use strict';

    angular.module('remitEventsApp').config(function($locationProvider, $translateProvider, tmhDynamicLocaleProvider, blockUIConfig) {
        blockUIConfig.delay = 0;
        blockUIConfig.message = 'Loading...';
        blockUIConfig.templateUrl = '/scripts/components/uiblocker/angular-block-ui.ng.html';

        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $locationProvider.hashPrefix('');

        $translateProvider.preferredLanguage('pl');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    });
})();
